import ReturnsPage from 'components/yggdrasil/organisms/returns/components/ReturnsPage';
import { Order } from 'shared/types/cart';

export interface Props {
  order: Order;
}

const ReturnPage: React.FC<Props> = ({ order }) => {
  return (
    order && (
      <>
        <ReturnsPage order={order} />
      </>
    )
  );
};

export default ReturnPage;
